import React, { Fragment, h } from "preact";
import './Table.scss';

export default function TableHead ({children, className}) {
    const classNameStyle = className ? className : 'default';

    return (
        <div className={`component-table__head ${classNameStyle}`}>
            {children}
        </div>
    )
}